<div class="report-date-range">
  <div class="date-presets">
    <button type="button" class="preset-btn" (click)="dateRange.setPreset('today')">Today</button>
    <button type="button" class="preset-btn" (click)="dateRange.setPreset('last7')">Last 7 days</button>
    <button type="button" class="preset-btn" (click)="dateRange.setPreset('last30')">Last 30 days</button>
    <button type="button" class="preset-btn" (click)="dateRange.setPreset('thisMonth')">This month</button>
    <button type="button" class="preset-btn" (click)="dateRange.setPreset('lastMonth')">Last month</button>
  </div>
  <div class="date-range" [class.invalid]="showError">
    <input
      type="date"
      name="reportStartDate"
      [ngModel]="dateRange.draftStartDate()"
      (ngModelChange)="onStartDateChange($event)"
      aria-label="Report start date"
    />
    <span>to</span>
    <input
      type="date"
      name="reportEndDate"
      [ngModel]="dateRange.draftEndDate()"
      (ngModelChange)="onEndDateChange($event)"
      aria-label="Report end date"
    />
  </div>
  <button
    type="button"
    class="btn btn-primary"
    (click)="generate()"
    [disabled]="!dateRange.isDraftValid()"
  >
    <i class="bi bi-arrow-clockwise"></i> Generate
  </button>
  @if (showError) {
    <span class="date-range-error">End date must be on or after the start date.</span>
  }
</div>
